// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
Development Ribbon
========================================================================== */
.ribbon {
  display: none;
  background-color: rgba(170, 0, 0, 0.5);
  left: -3.5em;
  transform: rotate(-45deg);
  overflow: hidden;
  position: absolute;
  top: 40px;
  white-space: nowrap;
  width: 15em;
  z-index: 99999;
  pointer-events: none;
  opacity: 0.75;
}
.ribbon a {
  color: #fff;
  display: block;
  font-weight: 400;
  margin: 1px 0;
  padding: 10px 50px;
  text-align: center;
  text-decoration: none;
  text-shadow: 0 0 5px #444;
  pointer-events: none;
}

/* ==========================================================================
Navbar styles
========================================================================== */
.mpgi-navbar {
  background-color: #3a516e;
  padding: 0.2em 1em;
  height: 70px;
}
.mpgi-navbar .profile-image {
  margin: -10px 0px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
}
.mpgi-navbar .dropdown-item.active,
.mpgi-navbar .dropdown-item.active:focus,
.mpgi-navbar .dropdown-item.active:hover {
  background-color: #353d47;
}
.mpgi-navbar .dropdown-toggle::after {
  margin-left: 0.15em;
}
.mpgi-navbar ul.navbar-nav {
  padding: 0.5em;
}
.mpgi-navbar ul.navbar-nav .nav-item {
  margin-left: 1.5rem;
}
.mpgi-navbar a.nav-link {
  font-weight: 400;
}
.mpgi-navbar a.nav-link > span {
  margin-left: 5px;
}
.mpgi-navbar .mpgi-navbar-toggler {
  color: #ccc;
  font-size: 1.5em;
  padding: 10px;
}
.mpgi-navbar .mpgi-navbar-toggler:hover {
  color: #fff;
}

.navbar-brand {
  overflow: hidden;
}

.mpgi-navbar .navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.navbar-version {
  font-size: 0.65em;
  color: #bbb;
  padding: 0 0 0 10px;
}

.brand-logo:hover {
  text-decoration: none;
}
.brand-logo .brand-icon {
  height: 60px;
  width: auto;
  display: inline;
}
.brand-logo .brand-icon img {
  width: 150px;
}

.brand-title {
  font-size: 1.25rem;
  margin-left: 0.25rem;
  color: #fff;
}
.brand-title:hover {
  color: #cccccc;
  text-decoration: none;
}

.loading-bar {
  height: 3px;
  background-color: #009cd8;
  position: absolute;
  top: 0px;
  z-index: 1031;
}

.global-notification {
  background-color: #ffebcd;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/layout/header/header.scss","webpack://./node_modules/edozvola-frontend-lib/dist/assets/css/00-settings/_colors.scss"],"names":[],"mappings":"AAOA;;4EAAA;AAGA;EACE,aAAA;EACA,sCAAA;EACA,YAAA;EAKA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;EACA,aAAA;AANF;AAOE;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;AALJ;;AASA;;4EAAA;AAGA;EACE,yBC3CQ;ED4CR,kBAAA;EACA,YAAA;AANF;AAOE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AALJ;AAOE;;;EAGE,yBAAA;AALJ;AAOE;EACE,mBAAA;AALJ;AAOE;EACE,cAAA;AALJ;AAMI;EACE,mBAAA;AAJN;AAOE;EACE,gBAAA;AALJ;AAMI;EACE,gBAAA;AAJN;AAOE;EACE,WAAA;EACA,gBAAA;EACA,aAAA;AALJ;AAMI;EACE,WAAA;AAJN;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;EACA,eAAA;AALF;;AAQA;EACE,iBAAA;EACA,WA1FuB;EA2FvB,mBAAA;AALF;;AASE;EACE,qBAAA;AANJ;AAQE;EACE,YAAA;EACA,WAAA;EACA,eAAA;AANJ;AAOI;EACE,YAAA;AALN;;AAUA;EACE,kBAAA;EACA,oBAAA;EACA,WAhHa;AAyGf;AAQE;EACE,cAhHiB;EAiHjB,qBAAA;AANJ;;AAUA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;AAPF;;AAUA;EACE,yBA7HiC;EA8HjC,kBAAA;AAPF","sourcesContent":["@import 'edozvola-frontend-lib/dist/assets/css/00-settings/colors';\n\n$header-color: #fff;\n$header-color-secondary: #bbb;\n$header-color-hover: darken($header-color, 20%);\n$header-color-global-notificaiton: #ffebcd;\n\n/* ==========================================================================\nDevelopment Ribbon\n========================================================================== */\n.ribbon {\n  display: none;\n  background-color: rgba(170, 0, 0, 0.5);\n  left: -3.5em;\n  -moz-transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n  -o-transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  overflow: hidden;\n  position: absolute;\n  top: 40px;\n  white-space: nowrap;\n  width: 15em;\n  z-index: 99999;\n  pointer-events: none;\n  opacity: 0.75;\n  a {\n    color: #fff;\n    display: block;\n    font-weight: 400;\n    margin: 1px 0;\n    padding: 10px 50px;\n    text-align: center;\n    text-decoration: none;\n    text-shadow: 0 0 5px #444;\n    pointer-events: none;\n  }\n}\n\n/* ==========================================================================\nNavbar styles\n========================================================================== */\n.mpgi-navbar {\n  background-color: $primary;\n  padding: 0.2em 1em;\n  height: 70px;\n  .profile-image {\n    margin: -10px 0px;\n    height: 40px;\n    width: 40px;\n    border-radius: 50%;\n  }\n  .dropdown-item.active,\n  .dropdown-item.active:focus,\n  .dropdown-item.active:hover {\n    background-color: #353d47;\n  }\n  .dropdown-toggle::after {\n    margin-left: 0.15em;\n  }\n  ul.navbar-nav {\n    padding: 0.5em;\n    .nav-item {\n      margin-left: 1.5rem;\n    }\n  }\n  a.nav-link {\n    font-weight: 400;\n    > span {\n      margin-left: 5px;\n    }\n  }\n  .mpgi-navbar-toggler {\n    color: #ccc;\n    font-size: 1.5em;\n    padding: 10px;\n    &:hover {\n      color: #fff;\n    }\n  }\n}\n.navbar-brand {\n  overflow: hidden;\n}\n\n.mpgi-navbar .navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.navbar-version {\n  font-size: 0.65em;\n  color: $header-color-secondary;\n  padding: 0 0 0 10px;\n}\n\n.brand-logo {\n  &:hover {\n    text-decoration: none;\n  }\n  .brand-icon {\n    height: 60px;\n    width: auto;\n    display: inline;\n    img {\n      width: 150px;\n    }\n  }\n}\n\n.brand-title {\n  font-size: 1.25rem;\n  margin-left: 0.25rem;\n  color: $header-color;\n  &:hover {\n    color: $header-color-hover;\n    text-decoration: none;\n  }\n}\n\n.loading-bar {\n  height: 3px;\n  background-color: #009cd8;\n  position: absolute;\n  top: 0px;\n  z-index: 1031;\n}\n\n.global-notification {\n  background-color: $header-color-global-notificaiton;\n  text-align: center;\n}\n","// Main colors\n$primary: #3a516e;\n$secondary: #343a40;\n\n// Misc Colors\n$green: #17aa55;\n$green-light: #88dda9;\n\n$red: #ca1820;\n$red-light: #d85b61;\n$red-lighter: #e9a7a9;\n$red-lightest: #f4d3d4;\n$yellow: #ffce00;\n\n$blue: #199cb4;\n$blue-light: #5fcde2;\n\n$primary-lighter: #607a9b;\n$primary-lightest: #aaccf8;\n\n$black: #000000;\n$white: #fff;\n\n$gray-dark: #828a90;\n$gray: #adb5bd;\n$gray-light: rgba(233, 236, 239, 0.6);\n$gray-lighter: #f4f5f7;\n\n// Alerts colors\n$success: #19b45a;\n$info: $blue;\n$warning: #f5d8d9;\n$danger: $primary;\n$default: $gray;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
